import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const mapyIconCss = ":host{display:inline-block}:host(:not([size])),:host([size=\"24\"]){width:24px;height:24px}:host([size=\"8\"]){width:8px;height:8px}:host([size=\"16\"]){width:16px;height:16px}:host([size=\"32\"]){width:32px;height:32px}:host svg{display:block;width:100%;height:100%;fill:currentColor}:host svg path:nth-child(2){color:var(--Icon-Secondary, currentColor)}";

const MapyIcon$1 = /*@__PURE__*/ proxyCustomElement(class MapyIcon extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 24;
  }
  render() {
    return (h(Host, null, h("svg", { x: "0px", y: "0px", viewBox: `0 0 ${this.size} ${this.size}`, focusable: "false" }, Array.from(this.hostElement.children).map(child => h("path", { "fill-rule": "evenodd", d: `${child.hasAttribute('d') ? child.getAttribute('d') : ''}` })))));
  }
  get hostElement() { return this; }
  static get style() { return mapyIconCss; }
}, [1, "mapy-icon", {
    "size": [514]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["mapy-icon"];
  components.forEach(tagName => { switch (tagName) {
    case "mapy-icon":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, MapyIcon$1);
      }
      break;
  } });
}
defineCustomElement$1();

const MapyIcon = MapyIcon$1;
const defineCustomElement = defineCustomElement$1;

export { MapyIcon, defineCustomElement };

//# sourceMappingURL=mapy-icon.js.map